import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity, UserPlus, Plane, ShieldCheck, MessageSquare, Gift, RefreshCw, Star, Lock } from "lucide-react";

const ACTION_ICONS = {
  "auth.register": UserPlus,
  "auth.forgot_password": Lock,
  "auth.reset_password": Lock,
  "trip.create": Plane,
  "trip.postcard": Plane,
  "contact.unlock.credit": Gift,
  "escrow.release": ShieldCheck,
  "referral.reward": Gift,
  "referral.double_bonus": Gift,
  "admin.simulate.seed": Activity,
  "admin.simulate.release": ShieldCheck,
  "admin.reset_sandbox": RefreshCw,
  "verify.phone": MessageSquare,
  "subscription.activate": Star,
};

export default function ActivityFeed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const r = await api.get("/admin/activity?limit=30"); setItems(r.data); }
    catch (err) { console.error("activity", err); }
    finally { setLoading(false); }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="glass rounded-xl overflow-hidden">
      <div className="px-4 py-2 border-b border-slate-800 flex items-center justify-between">
        <div className="text-sm font-semibold flex items-center gap-2"><Activity size={14} className="text-[#F59E0B]"/> Fil d'activité temps réel</div>
        <span className="text-[10px] text-slate-500 flex items-center gap-1"><span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"/> live</span>
      </div>
      <div className="max-h-80 overflow-y-auto divide-y divide-slate-800/60">
        {loading && <p className="text-center text-slate-500 py-8 text-xs">Chargement…</p>}
        {!loading && items.length === 0 && <p className="text-center text-slate-500 py-8 text-xs">Aucun événement.</p>}
        {items.map(it => {
          const Ic = ACTION_ICONS[it.action] || Activity;
          return (
            <div key={it.log_id} data-testid={`activity-${it.log_id}`} className="px-4 py-2 flex items-start gap-3 hover:bg-slate-900/40">
              <div className="w-7 h-7 rounded-lg bg-slate-800 flex items-center justify-center shrink-0"><Ic size={14} className="text-[#F59E0B]"/></div>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-semibold text-slate-200 truncate">
                  <span className="text-[#F59E0B]">{it.action}</span>
                  <span className="text-slate-400"> · {it.actor?.name || "system"}</span>
                </div>
                <div className="text-[11px] text-slate-500 truncate">{Object.entries(it.meta || {}).map(([k,v])=>`${k}:${typeof v==='string' && v.length>20 ? v.slice(0,17)+'…' : v}`).join(" ")}</div>
              </div>
              <div className="text-[10px] text-slate-500 whitespace-nowrap">{new Date(it.at).toLocaleTimeString("fr-FR")}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
